export const ticketViewCheck = {
  path: '/api/v1/tickets',
  method: 'GET',
};

export const ticketCreateCheck = {
  path: '/api/v1/tickets',
  method: 'POST',
};

export const ticketEditCheck = {
  path: '/api/v1/tickets',
  method: 'PUT',
};

export function getTicket(ticketId) {
  return {
    path: `tickets/${ticketId}`,
    method: 'GET',
  };
}

export function searchTickets(search, contentType) {
  return {
    accept: contentType,
    path: `tickets${search}`,
  };
}

export function getEmployeeTickets(search) {
  return {
    path: `employee_tickets${search}`,
  };
}

export function createTicket(description) {
  return {
    path: 'tickets',
    body: JSON.stringify(description),
    method: 'POST',
  };
}

export function updateTicket(ticketId, description) {
  return {
    path: `tickets/${ticketId}`,
    method: 'PUT',
    body: JSON.stringify(description),
  };
}

export function updateTicketTags(ticketId, description) {
  return {
    path: `tickets/${ticketId}/tags`,
    method: 'PUT',
    body: JSON.stringify(description),
  };
}

export function getTicketAssociation(associationId) {
  return { path: `associations/${associationId}` };
}

export function updateTicketAssociation(associationId, description) {
  return {
    path: `associations/${associationId}`,
    method: 'PUT',
    body: JSON.stringify(description),
  };
}

export function addAssignee(description) {
  return {
    path: 'assignments',
    method: 'POST',
    body: JSON.stringify(description),
  };
}

export function updateContact(id, description) {
  return {
    path: `security_contacts/${id}`,
    method: 'PUT',
    body: JSON.stringify(description),
  };
}

export function createContact(description) {
  return {
    path: 'security_contacts',
    method: 'POST',
    body: JSON.stringify(description),
  };
}

export function addMergedTicket(description) {
  return {
    path: 'entries/merge',
    method: 'POST',
    body: JSON.stringify(description),
  };
}

export function addEntry(description) {
  return {
    path: 'entries',
    method: 'POST',
    body: JSON.stringify(description),
  };
}

export function updateEntry(entryId, description) {
  return {
    path: `entries/${entryId}`,
    method: 'PUT',
    body: JSON.stringify(description),
  };
}

export function getEntry(entryId) {
  return { path: `entries/${entryId}` };
}

export function addResolution(ticketId, description) {
  return {
    path: `tickets/${ticketId}/ticket_resolutions`,
    method: 'POST',
    body: JSON.stringify(description),
  };
}

export function deleteResolution(ticketId) {
  return {
    path: `tickets/${ticketId}/ticket_resolutions`,
    method: 'DELETE',
  };
}

export function updateResolution(ticketId, description) {
  return {
    path: `tickets/${ticketId}/ticket_resolutions`,
    method: 'PUT',
    body: JSON.stringify(description),
  };
}

export function createTag(description) {
  return {
    path: 'tags',
    method: 'POST',
    body: JSON.stringify(description),
  };
}

export function updateTag(tagId, description) {
  return {
    path: `tags/${tagId}`,
    method: 'PUT',
    body: JSON.stringify(description),
  };
}

export function getTag(tagId) {
  return { path: `tags/${tagId}` };
}

export function verifySecurityTicketTag(tagId) {
  return { path: `tags/${tagId}/is_security_type` };
}

export function searchTags(search, contentType) {
  return {
    accept: contentType,
    path: `tags${search}`,
  };
}

export function deleteTag(tagId) {
  return {
    path: `tags/${tagId}`,
    method: 'DELETE',
  };
}

export function getResolutions(typeId) {
  return { path: `resolution/${typeId}` };
}

export const searchResolutions = (search) => ({ path: `tags/resolutions${search}` });

export function createWorkOrderPdf(formType, ticketId) {
  return {
    path: `tickets/${ticketId}/work_orders/${formType}`,
    accept: 'application/pdf',
    method: 'GET',
  };
}
